<template>
    <div class="order-quote-modal">
        <div
            v-show="success"
            class="alert alert-success"
        >
            <p>
                Vielen Dank für Deine Offertanfrage beim Öpfelchasper, wir bearbeiten sie so schnell wie möglich.
            </p>
        </div>

        <div
            v-show="error"
            class="alert alert-danger"
        >
            <p>
                Deine Anfrage konnte nicht übermittelt werden.<br>
                Bitte versuche es später noch einmal oder kontaktiere uns per Telefon oder E-Mail:
                <br><br>
                <a href="tel:+41438186152">043 818 61 52</a><br>
                <a href="mailto:info@oepfelchasper.ch">info@oepfelchasper.ch</a>
            </p>

        </div>

        <div
            v-show="(!success && !error)"
        >
            <header class="order-quote-modal__header">
                <h3 class="order-quote-modal__heading">
                    Offertanfrage
                </h3>
            </header>
            <form ref="quoteForm" @submit.prevent="validateForm">

                <div class="order-quote-form">

                    <div class="order-address-form">
                        <div class="order-address-form__form form-default">
                            <div class="order-quote-form__employees form-group">
                                <number-employees/>
                            </div>
                        </div>
                    </div>

                    <address-form
                        ref="addressForm"
                        :validate-form="validateForm"
                        :early-invoice-text="'Wir möchten unsere Bestellung jeweils vor 10 Uhr morgens erhalten.<br>Der Aufpreis für die Öpfelchasper-Frühlieferung beträgt 5 CHF pro Lieferung.'"
                        firm-required
                    />

                    <div class="order-quote-form__btn-container">
                        <a
                            href="#"
                            class="btn btn-default"
                            @click.prevent="validateForm"
                        >
                            Senden
                        </a>
                    </div>

                </div>

            </form>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'; // eslint-disable-line
import { validationMixin } from 'vuelidate';
import {
    numeric,
    required,
} from 'vuelidate/lib/validators';
import { mapState } from 'vuex';

import NumberEmployees from './Fields/NumberEmployees.vue';
import AddressForm from '../Forms/Address.vue';

export default {
    components: {
        NumberEmployees,
        AddressForm,
    },
    mixins: [validationMixin],
    data() {
        return {
            address: 'quote',
            error: false,
            success: false,
            form: {
                quote: {},
            },
        };
    },
    validations() {
        return {
            form: {
                quote: {
                    numberEmployees: {
                        required,
                        numeric,
                    },
                },
            },
        };
    },
    computed: {
        ...mapState({
            mode: state => state.mode,
        }),
    },
    methods: {
        validateForm() {
            const $heading = $('.order-quote-modal__heading');
            // check for errors and empty, required fields
            this.$v.$touch();
            this.$refs.addressForm.$refs.invoiceAddress.$v.$touch();
            this.$refs.addressForm.$refs.deliveryAddress.$v.$touch();
            // if there are errors, jump to make them visible to the user
            if (
                this.$v.form.$invalid ||
                this.$v.form.$error ||
                this.$refs.addressForm.$refs.deliveryAddress.$v.form.$invalid ||
                this.$refs.addressForm.$refs.deliveryAddress.$v.form.$error ||
                this.$refs.addressForm.$refs.invoiceAddress.$v.form.$invalid ||
                this.$refs.addressForm.$refs.invoiceAddress.$v.form.$error
            ) {
                window.scrollTo(0, $heading.offset().top);
            } else { // if no errors, send quote
                this.sendQuote();
            }
        },
        sendQuote() {
            const { numberEmployees } = this.form.quote;
            const addressForm = this.$refs.addressForm;
            const { invoiceAddress } = addressForm.$refs.invoiceAddress.form;
            const { deliveryAddress } = addressForm.$refs.deliveryAddress.form;

            // show loading modal
            this.$store.dispatch('showLoadingModal', {
                message: 'Deine Anfrage wird bearbeitet.',
            });

            // prepare order, save addresses
            this.$store.dispatch('updateOrder', {
                invoiceAddress,
                deliveryAddress,
                attentionBy: addressForm.$refs.deliveryAddress.form.attention_by,
                comment: addressForm.$refs.deliveryAddress.form.comment,
            });

            // send order to whatwedo API
            this.$store.dispatch('sendQuote', { numberEmployees })
                .then(
                    () => {
                        this.$store.dispatch('hideLoadingModal'); // hide loading
                        this.success = true;
                        this.addDataLayerEvent();
                    },
                    () => {
                    // error handling
                        this.$store.dispatch('hideLoadingModal'); // hide loading
                        this.error = true;
                    },
                );
        },
        addDataLayerEvent() {
            if (typeof window.dataLayer !== 'undefined') {
                window.dataLayer.push({
                    event: 'quote-form.sent',
                });
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// OrderQuote.vue?0452b6fc